import FeaturedInsight from "./FeaturedInsight";

export default FeaturedInsight